import React, { VFC } from 'react';
import T from 'i18n-react';

import {
  V1UsersitePlansAtmosphereSliderManyTypeOnePayload,
  V1UsersitePlansAtmosphereSliderManyTypePayloadKind,
} from '~/models/schema';
import OtetsukunLogo from '~/images/icons/logo.png';
import SliderWithLabel from './SliderWithLabel';

interface Props {
  atmosphereSlider: V1UsersitePlansAtmosphereSliderManyTypeOnePayload;
}
const AtmosphereSlider: VFC<Props> = ({ atmosphereSlider }: Props) => {
  const isShowMarksLabel =
    atmosphereSlider.kind ===
    V1UsersitePlansAtmosphereSliderManyTypePayloadKind.AGE_GROUP;
  const marks = [...Array(atmosphereSlider.selectNumber).keys()].map((i) => ({
    value: i,
    ...(isShowMarksLabel && { label: `${(i + 2) * 10}代` }),
  }));

  return (
    <SliderWithLabel
      key={atmosphereSlider.id}
      disabled
      value={atmosphereSlider.values.map(Number)}
      ThumbComponent={LabelImage}
      marks={marks}
      track={false}
      step={1}
      min={0}
      max={atmosphereSlider.selectNumber - 1}
      startLabel={T.translate(
        `atmosphereSlider.startLabel.${atmosphereSlider.kind}`,
      )}
      endLabel={T.translate(
        `atmosphereSlider.endLabel.${atmosphereSlider.kind}`,
      )}
    />
  );
};

export default AtmosphereSlider;

const LabelImage = (props) => (
  <span {...props}>
    <img src={OtetsukunLogo} alt="otetsukun" width="22" />
  </span>
);
